const sessionSchema = `
  id
  name
  workspace
  codeSiteComptage
  start_time
  end_time
  max_participant
  activity
  participants
  product_activity {
    product
    activity
  }
  products
  recurring
  recurring_uuid
  end_recurring_date
  pre_reserved_participants {
    items {
      id
      lastname
      firstname
    }
}`;

export { sessionSchema };